<template>
  <el-card
    class="inventory-card"
    :body-style="{ height: '100%', 'background-color': 'var(--nxt-color-lightest-blue)'}">
    <div class="inventory-card__body">
      <div>
        <font-awesome-icon
          :icon="['fal', 'clipboard-list-check']"
          class="descriptifs__cards__icon"
          size="2x"
        />
      </div>
      <h3 class="inventory-card__body__h3 center-v-h">
        {{ $t('home.descriptifsCards.myInventory') }}
      </h3>
      <p class="inventory-card__body__text to-upper-case center-v-h">
        {{ $t('home.descriptifsCards.inventoryText') }}
      </p>
      <div class="inventory-card__body__button">
        <router-link :to="{ name: 'inventory' }">
          <el-button
            type="primary">
            {{ $t('home.descriptifsCards.see') }}
          </el-button>
        </router-link>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'inventoryCard',
};
</script>

<style scoped lang="scss">
.inventory-card {
  margin-bottom: 20px;
  border-radius: 0;
  border: none;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0;
  }
  &__body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;
    height: 100%;
    &__h3 {
      margin-top: 10px;
      margin-bottom: 0;
      height: 60px;
    }
    &__text {
      margin: 10px 0;
      font-size: 16px;
      flex: 1 1;
    }
  }
}
</style>
